  //- Set current Year to footer Copyright
  let thisDate = new Date();
  $('#year').html(thisDate.getFullYear());

